import { styled } from '@mui/system';
import MuiChip from '@mui/material/Chip';
import colors from '../../assets/colors';

const StyledChip = styled(MuiChip)({
  background: colors.agroweGreen,
  color: colors.white,
  p: 2,
  fontWeight: 600,
});

const Chip = (props) => <StyledChip {...props} />;
export default Chip;
